var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-empty"},[_c('img',{attrs:{"src":require("@/assets/style/img/empty.png"),"alt":""}}),_c('div',{staticClass:"empty-text",domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._t("index-empty-tip")],2)}
var staticRenderFns = []

export { render, staticRenderFns }